/**
 * Polish translations for the heartbeat component.
 *
 * These translations provide Polish language support for all
 * heartbeat banner messages and user interface text.
 */
const translations = {
	'security.heartbeat.banner.session-expires-prefix': 'Twoja sesja wygasa za',
	'security.heartbeat.banner.session-expired': 'Twoja sesja wygasła',
	'security.heartbeat.banner.less-than-one-minute': 'mniej niż 1 minutę',
	'security.heartbeat.banner.minute': 'minutę',
	'security.heartbeat.banner.minutes': 'minut',
	'security.heartbeat.banner.hour': 'godzinę',
	'security.heartbeat.banner.hours': 'godzin',
	'security.heartbeat.banner.and': 'i',
	'security.heartbeat.banner.keep-me-signed-in.label': 'Pozostaw mnie zalogowanego',
	'security.heartbeat.banner.remind-me-later.label': 'Przypomnij mi później',
	'security.heartbeat.banner.warning-icon.label': 'Ostrzeżenie',
	'security.heartbeat.banner.login-again.link': 'Zaloguj się ponownie, aby kontynuować',
};

export default translations;
